import { Button } from '@cleartax/wg-library-button';
import { If } from '@cleartax/wg-library-conditionals';
import { SkeletonLoader } from '@cleartax/wg-library-loader';
import { Text } from '@cleartax/wg-library-typography';
import { CLEARTAX_DOMAIN } from '../../../../../../config/constants';
import { trackAction } from '../../../../../../shared';
import {
  getCommaFormat,
  getCurrencyFromUnicode,
} from '../../../../../../shared/utils/utils/index';
import { usePlanCtx } from '../../planDetailsContext';
import { getPercentageDiff } from '../../utils';
import { getNewListingId } from './utils';

interface IHeroPriceCard {
  seoSlug: string;
  planName: string;
  symbol: string;
  listingId: string;
}

export const HeroPriceCard: React.FC<IHeroPriceCard> = ({
  seoSlug,
  planName,
  symbol,
  listingId,
}: IHeroPriceCard) => {
  const { getPlanPriceDetailsApi } = usePlanCtx();
  const { data, isLoading, error } = getPlanPriceDetailsApi;
  const discountedPrice = data.totalAmount - data.tax;
  const originalPrice = data.originalPrice;
  const discountPercentage = getPercentageDiff(originalPrice, discountedPrice);
  const newListingId = getNewListingId(listingId);
  const checkoutUrl = `${CLEARTAX_DOMAIN}/checkout/${newListingId}`;

  return (
    <div className="rounded-3xl bg-grey-100 h-auto mx-auto shadow-md text-center py-6 px-12 w-3/4 sm:w-full">
      <Text textSize="lg" className="text-brand-1000" weight="bold">
        {planName}
      </Text>
      <SkeletonLoader isLoading={isLoading}>
        <Text
          textSize="4xl"
          className={`text-brand-1000 mt-4 h-10`}
          weight="bold"
        >
          {!isLoading && !error
            ? `${getCurrencyFromUnicode(symbol)}${getCommaFormat(
                discountedPrice
              )}`
            : '$1,000'}
        </Text>
      </SkeletonLoader>
      <SkeletonLoader classNames="h-6" isLoading={isLoading}>
        <div className="flex mt-2 items-center text-center justify-center">
          <If condition={!!data.discountPercentage}>
            <Text className={`text-grey-700 line-through `}>
              {!isLoading && !error
                ? `${getCurrencyFromUnicode(symbol)}${getCommaFormat(
                    originalPrice
                  )}`
                : '$1000'}
            </Text>
            <Text weight="extrabold" className={`text-red-600 pl-2 `}>
              {'(' + Math.floor(discountPercentage) + '% OFF)'}
            </Text>
          </If>
        </div>
      </SkeletonLoader>
      <Text type="a" className="pt-2 w-full" href={checkoutUrl}>
        <Button
          onClick={() => {
            trackAction('click', '', {
              label: `buy_now_product_page_${seoSlug}`,
            });
          }}
          variant="blue"
          rounded="lg"
          className="w-full mt-2"
        >
          Buy now
        </Button>
      </Text>
    </div>
  );
};
